import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "clickdtf_cookie_consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="lgpd-cookie-banner"
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-3xl rounded-2xl border border-neutral-200 bg-white/95 p-4 shadow-2xl backdrop-blur-xl sm:inset-x-6 sm:bottom-6 sm:p-5"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <Cookie className="hidden h-6 w-6 shrink-0 text-[#f58244] sm:block" />
            <p className="text-xs leading-relaxed text-neutral-600 sm:text-[13px]">
              Utilizamos cookies para melhorar sua experiência e medir o uso das
              nossas ferramentas gratuitas. Ao continuar navegando, você
              concorda com o uso de cookies, em conformidade com a{" "}
              <strong className="text-black">LGPD</strong> (Lei nº 13.709/2018).
            </p>
            <div className="flex shrink-0 gap-2">
              <button
                type="button"
                onClick={() => setVisible(false)}
                data-testid="lgpd-decline-button"
                className="rounded-full border border-neutral-200 px-4 py-2.5 text-xs font-semibold text-neutral-600 transition-colors hover:border-black hover:text-black"
              >
                Agora não
              </button>
              <button
                type="button"
                onClick={accept}
                data-testid="lgpd-accept-button"
                className="rounded-full bg-[#f58244] px-5 py-2.5 text-xs font-bold text-white transition-colors hover:bg-[#e06f32]"
              >
                Aceitar e continuar
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
